// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import t from 'tcomb';

const ClaimLabor = t.struct({
    guid: t.String,
    id: t.String,
    laborAdditive: t.maybe(t.Number),
    laborHours: t.maybe(t.Number),
    laborType: KeyValuePair,
    laborValue: t.maybe(t.Number),
    lineNumber: t.Number,
    location: KeyValuePair,
    reimbursementAmount: t.maybe(t.Number),
    spgJobCode: t.String,
    taxAmount: t.maybe(t.Number),
    techId: t.String,
    unit: t.maybe(t.String)
}, {
    name: 'ClaimLabor',
    strict: true
});

export const getDefaultState = () => new ClaimLabor({
    guid: '',
    id: '',
    laborHours: null,
    laborType: getKeyValueDefaultState(),
    lineNumber: 0,
    location: getKeyValueDefaultState(),
    spgJobCode: '',
    techId: ''
});

export default ClaimLabor;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-item-labor.js